import src from "IMAGE";
export default { src, width: 141, height: 34, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFZzGIY/Xht2DRAINAYGBi0GBgYrBgYGLwYGBiwGBgYvAGR6EYVXaQ1zDhEIPwsLC08LCwtRCQkJQwkJCUcJCQlJUPcJSznmz3EAAAAASUVORK5CYII="};
